import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
} from 'shards-react';

import VChart from './VChart';

const chartOptions = {
  responsive: true,
  scales: {
    xAxes: [
      {
        gridLines: false,
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          maxTicksLimit: 10,
          minRotation: 0,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          precision: 0,
        },
      },
    ],
  },
};

const MonthlyUsers = ({ series, title }) => {
  const { datasets, labels, total } = useMemo(() => {
    const sortedSeries = [...(Array.isArray(series) ? series : [])]
      .map(item => ({
        count: Number(item?.count || 0),
        period: item?.period || item?._id,
      }))
      .filter(item => item.period && Number.isFinite(item.count))
      .sort(
        (first, second) => String(first.period).localeCompare(String(second.period)),
      );
    const counts = sortedSeries.map(item => item.count);

    return {
      labels: sortedSeries.map(item => item.period),
      datasets: [{
        data: counts,
        fill: 'start',
        label: `Users (${counts.reduce((sum, count) => sum + count, 0).toLocaleString('en-US')})`,
      }],
      total: counts.reduce((sum, count) => sum + count, 0),
    };
  }, [series]);

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </CardHeader>
      <CardBody className="pt-0">
        {labels.length > 0 && total > 0 ? (
          <VChart
            labels={labels}
            datasets={datasets}
            type="bar"
            height="240"
            chartOptions={chartOptions}
          />
        ) : (
          <div className="text-center text-muted p-4">
            No monthly user data
          </div>
        )}
      </CardBody>
    </Card>
  );
};

MonthlyUsers.propTypes = {
  series: PropTypes.array,
  title: PropTypes.string,
};

MonthlyUsers.defaultProps = {
  series: [],
  title: 'Users by month',
};

export default MonthlyUsers;
